export class PasswordUtils {
    public static validate = (password: string): boolean => {
        const isPasswordValid = password.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[.@$!%*?&])[A-Za-z\d.@$!%*?&]{8,32}$/);
        return !!isPasswordValid;
    }
}